// src/client/components/SectionLabel.tsx
// Editorial section heading: an uppercase eyebrow on the left + optional
// muted slot on the right. Used between cards/lists on every screen.
import type { ReactNode } from 'react';
import styles from './SectionLabel.module.css';

interface Props {
  children: ReactNode;
  right?: ReactNode;
  className?: string;
}

export default function SectionLabel({ children, right, className }: Props) {
  const cls = [styles.row, className].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <span className={styles.label}>{children}</span>
      {right && <span className={styles.right}>{right}</span>}
    </div>
  );
}
